module.exports = __webpack_public_path__ + "img/ECEHeader.1a056166.png";